

/* Warning: this file is auto-generated, any changes would be lost */
  
import React, { useEffect } from "react"

import "../src/assets/sass/main.scss"
import "typeface-roboto"

import Layout from "../src/components/layout"
import SEO from "../src/components/seo"

import { connect } from "react-redux"
import { setCorrespondingLangSlug, setToLanguage } from "../src/state/actions"
import { useTranslation } from 'react-i18next';



// Sections
import HeroVariantOne from '../src/layouts/HeroVariantOne';
import ProductGrid from '../src/layouts/ProductGrid';
import VideoTeaser from '../src/layouts/VideoTeaser';
import ComponentGrid from '../src/layouts/ComponentGrid';
import PricingTable from '../src/layouts/PricingTable';

const Page = ({ setCorrespondingLangSlug, setToLanguage, lang, correspondingLangSlug, pageContext }) => {
  const { i18n } = useTranslation()
  const page = pageContext.page
  
  const pageBuilder = page.pageBuilder.content || []

  const correspondingTranslation = page.translations.find((translation) => {
    return translation.language.locale !== page.language.locale
  })

  useEffect(() => {
    if (page.language.locale !== lang) {
      setToLanguage(page.language.locale)
      i18n.changeLanguage(page.language.locale)
    }

    if (correspondingTranslation && correspondingTranslation.fullSlug !== correspondingLangSlug) {
      setCorrespondingLangSlug(correspondingTranslation.fullSlug)
    }
  })
  return (
    <Layout>
      <SEO title={page.title} lang={page.language.locale}/>
      
      
      {
        pageBuilder.map((section, index) => {
          if (!section) {
            return null
          }
        
                if (section.fieldGroupName === 'page_Pagebuilder_Content_HeroVariantOne') {
                    return <HeroVariantOne {...section} key={index} />;
                }

                if (section.fieldGroupName === 'page_Pagebuilder_Content_ProductGrid') {
                    return <ProductGrid {...section} key={index} />;
                }

                if (section.fieldGroupName === 'page_Pagebuilder_Content_VideoTeaser') {
                    return <VideoTeaser {...section} key={index} />;
                }

                if (section.fieldGroupName === 'page_Pagebuilder_Content_ComponentGrid') {
                    return <ComponentGrid {...section} key={index} />;
                }

                if (section.fieldGroupName === 'page_Pagebuilder_Content_PricingTable') {
                    return <PricingTable {...section} key={index} />;
                }
        
          return <div>In AllComponents fehlt das Mapping der Komponente.</div>

        })

      }
    </Layout>
  )
}


const mapStateToProps = (state) => {
  return {
    lang: state.lang,
    correspondingLangSlug: state.correspondingLangSlug,
  }
}

const mapDispatchToProps = {
  setCorrespondingLangSlug,
  setToLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
